import React from 'react';
import { compose, withHandlers } from 'recompose';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import TableGrid from '../../../../../common/components/TableGrid/TableGrid';
import { GridCell } from '../../../../../common/components/Grid/Grid';
import { Pagination, StoreState } from '@mm/state/store-interfaces';
import { setRecipientsOrderBy } from '@mm/state/modules/recipientsTableState/actions';
import './ChatBlastReportTable.scss';

type OuterProps = {
  campaignsUsers: any;
  onChangePagination: (pagingNumber: number) => void;
  pagination: Pagination;
};

type MapDispatchToPropsType = ReturnType<typeof mapDispatchToProps>;

type RenderDataCell = () => (field: string) => (field: any) => JSX.Element;

type WithFirstHandlersProps = {
  renderDataCell: RenderDataCell;
};

type HandlersFirstProps = {
  renderDataCell: ReturnType<RenderDataCell>;
};

type WithHandlersProps = WithFirstHandlersProps;

type HandlerProps = HandlersFirstProps;

type InnerProps = MapDispatchToPropsType & WithHandlersProps;

type Props = OuterProps & InnerProps & HandlerProps;

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  setRecipientsOrderBy: recipientsOrderBy =>
    dispatch(setRecipientsOrderBy(recipientsOrderBy)),
});

const renderDataCell: RenderDataCell = () => field => item =>
  <GridCell>{item && item[field]}</GridCell>;

const generateTableData = (
  renderDataCell: (field: string) => (field: any) => JSX.Element,
  setRecipientsOrderBy,
) => [
  {
    label: 'Status',
    keyName: 'status',
    onChange: setRecipientsOrderBy,
    renderCell: renderDataCell('status'),
  },
  {
    label: 'Name',
    keyName: 'name',
    onChange: setRecipientsOrderBy,
    renderCell: renderDataCell('name'),
  },
];

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
  withHandlers({ renderDataCell }),
);

const ChatBlastReportTable = (props: Props) => {
  const {
    setRecipientsOrderBy,
    campaignsUsers,
    pagination,
    onChangePagination,
    renderDataCell,
  } = props;

  const data = generateTableData(renderDataCell, setRecipientsOrderBy);

  return (
    <div className="report-table-wrapper">
      <TableGrid
        className="report-table"
        data={data}
        items={campaignsUsers}
        pagination={pagination}
        onChangePagination={onChangePagination}
      />
    </div>
  );
};

export default enhance(ChatBlastReportTable);
